const filterFiles = (arrayOfFileUploadFields, values, data) => {
  arrayOfFileUploadFields.forEach((field) => {
    values["files"].filter((file) => file.machine_name === field).length > 0
      ? (data[field] = "YES")
      : (data[field] = "NO");
  });
};

const fileUploadFields = [
  "emergencyJustification",
  "tempneedDoc",
  "attyIsAgreementAttached",
  //not updated
  "e21a_is_mspa_uploaded",
  "swaJoborderAttached",
  "jobDutiesAttached",
  //not updated
  "g2_mspa_attached",
  "empIsContractAttached",
  "empflrecEngageH2bAttached",
  "declareIsConfmApdxB",
  "declareConfmEmp",
];

const cleanData = (values) => {
  let filterArray = ["_", "__typename"];

  if (!values["files"]) {
    values["files"] = [];
  }

  fileUploadFields.forEach((field) => {
    if (values[field] && typeof values[field] === "object") {
      values["files"] = values["files"].concat(values[field]);
      values[field] = "YES";
    }
  });

  // Must be after forEach loop
  let data = { ...values };

  filterArray.map((x) => {
    delete data[x];
    return data;
  });

  // console.log("DATA HERE----------------------------", data, values);

  if (values["files"]) {
    filterFiles(fileUploadFields, values, data);
    if (values["files"].length > 0) {
      for (let j = 0; j < values["files"].length; j++) {
        let fileItem = { ...data["files"][j] };
        fileItem.size = fileItem.size.toString();

        delete fileItem.fileTypes;
        fileItem.lastModified = fileItem.lastModified.toString();

        delete fileItem.fileUploadedFrom;
        if (fileItem.__typename) {
          delete fileItem.__typename;
        }
        data["files"][j] = fileItem;
      }
    }
  }

  if (values?.["capSubject"]) {
    data["capSubject"] = Number(values["capSubject"]);
  }
  if (values?.["capExempt"]) {
    data["capExempt"] = Number(values["capExempt"]);
  }

  if (values?.["externalOtherDocPreface"] === "NO") {
    data["empIsContractAttached"] = "N/A";
  }

  return data;
};

export { cleanData };
